import {useState,createContext, useEffect} from 'react';

const useSetMemory = memArr => {

    const [selectedMemory, setSelectedMemory] = useState();

    useEffect(()=>{
        if (memArr) setSelectedMemory(memArr);
    },[memArr])
    return {
        selectedMemory,
        setSelectedMemory
    }
}

export const MemoryContext = createContext();
export default useSetMemory;